// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__CL1Qh","col":"Table_col__36aPJ","fulfillmentStatus":"Table_fulfillmentStatus__3J9Oz","emailCol":"Table_emailCol__srlK2"};